<template>
  <!-- 面试邀请 -->
  <div class="purse-body">
    <!-- 标题 -->
    <p class="title-Individual-center">
      求职管理 <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">面试邀请</span>
    </p>
    <!-- 内容主体 -->
    <div class="Content-subject">
      <!-- 切换 -->
      <div class="Toggle">
        <p
          v-for="(item, index) in selectArr"
          :key="index"
          :class="select == item.id ? 'select-p' : ''"
          @click="handelSelect(item.id)"
        >
          {{ item.name }}
        </p>
      </div>
      <!-- 表格 -->
      <div class="MainForm">
        <Interview :dataArr="dataArr"></Interview>
      </div>
      <!-- 分页 -->
      <div class="paging">
        <div class="paging-cen">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入接口
import {
  listUserInterviewRecord, //用户面试邀请记录
} from "../../../assets/api/JobInterview";
// 表格
import Interview from "./components/Interview.vue";
// 分页
import paging from "../../../components/paging.vue";
export default {
  data() {
    return {
      selectArr: [
        { name: "全部", id: "" },
        { name: "未面试", id: "4" },
        { name: "已面试", id: "3" },
      ],
      select: "", // 筛选
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 10, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      dataArr: [],
    };
  },
  components: {
    Interview,
    paging,
  },
  created() {
    this.listUserInterviewRecord();
  },
  methods: {
    // -----------------------用户面试邀请记录-------------
    async listUserInterviewRecord() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          status: this.select,
        },
      };
      const res = await listUserInterviewRecord(
        data,
        this.pagingObj.currentPage,
        this.pagingObj.pageSize
      );
      this.dataArr = res.data.list;
      this.pagingObj.totalDevice = res.data.total;
    },
    //筛选
    handelSelect(num) {
      this.select = num;
      this.listUserInterviewRecord();
    },
    // 分页
    handleCurrentChange(val) {
      this.pagingObj.currentPage = val;
      this.listUserInterviewRecord();
    },
  },
};
</script>

<style scoped lang="less">
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  font-size: 14px;
}
// 内容主体
.Content-subject {
  width: 100%;
  min-height: 540px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 切换
  .Toggle {
    width: 100%;
    height: 30px;
    display: flex;
    color: #333333;
    text-align: center;
    font-weight: 400;
    p:nth-child(1) {
      margin-left: 20px;
    }
    p {
      margin-right: 40px;
      font-size: 16px;
      cursor: pointer;
    }
    .select-p {
      color: #409eff ;
      box-sizing: border-box;
      border-bottom: 2px solid #409eff ;
    }
  }
  //表格
  .MainForm {
    width: 100%;
    min-height: 440px;
    margin-top: 30px;
  }
  // 分页
  .paging {
    max-width: 1230px;
    margin: auto;
    display: flex;
    margin-top: 30px;
    .paging-cen {
      margin: auto;
    }
  }
}
</style>
